const nameAttributeToObjectProperty = {
  'rfname': 'RomanizedFirstName',
  'rlname': 'RomanizedLastName',
  'rcname': 'RomanizedCompany',
  'preferredname': 'PreferredName',
  'dob': 'DateOfBirth',
  'url': 'personalURL',
  'taxid': 'TaxId1',
  'tin': 'TIN',
  'phone': 'phone1',
  'address-line-1': 'address1',
  'address-line-2': 'address2',
  'address-city': 'city',
  'address-state': 'state',
  'address-postal': 'postalCode',
  'shipping-address-line-1': 'shipAddress1',
  'shipping-address-line-2': 'shipAddress2',
  'shipping-address-city': 'shipCity',
  'shipping-address-state': 'shipState',
  'shipping-address-postal': 'shipPostalCode',
  'ship-phone': 'shipPhone',
  'MALDistributor': 'MALDistributor',
  'companyregistrationnumber': 'CompanyRegistrationNumber',
  'industriescode': 'IndustriesCode',
  'passportnumber': 'PassportNumber',
  'identitycardnumber': 'IdentityCardNumber',
};

const nameAttributeToInputPattern = {
  'rfname': /^[a-zA-Z]*$/,
  'rlname': /^[a-zA-Z]*$/,
  'rcname': /^[a-zA-Z ]*$/,
  'url': /^[a-zA-Z]*$/,
  'phone': /(^$)|(^\+?[\d+-]+$)/,
  'shipPhone': /(^$)|(^\+?[\d+-]+$)/,
};

const nameAttributeToAutoCompleteAttribute = {
  'address-line-1': 'address-line1',
  'address-line-2': 'address-line2',
  'address-city': 'address-level2',
  'address-state': 'address-level1',
  'shipping-address-line-1': 'address-line1',
  'shipping-address-line-2': 'address-line2',
  'shipping-address-city': 'address-level2',
  'shipping-address-state': 'address-level1',
};

// lookup table for name attribute conversion to which form object property it references.
export const createInputIdFromName = nameAttr => nameAttributeToObjectProperty[nameAttr] || nameAttr;

// lookup table for name attribute conversion to which pattern it references.
export const createInputPatternFromName = (nameAttr, country) => {
  if (nameAttr === 'taxid') {
    return country === 'KOREA (THE REPUBLIC OF)' ? /^\d{1,13}$/ : '';
  }

  return nameAttributeToInputPattern[nameAttr] || '';
};

// lookup table for name attribute conversion to autocomplete attribute.
export const createAutoCompleteAttrFromName = nameAttr => nameAttributeToAutoCompleteAttribute[nameAttr] || false;